import { useState } from "react";


import { FiSearch } from "react-icons/fi";
import AllPharmacyDetails from "../pharmacy/AllPharmacyDetails";
import StaffListTable from "./StaffListTable";
import StaffListGrid from "./StaffListGrid";
import { Modal } from "react-bootstrap";
import { RxCross2 } from "react-icons/rx";
import { LuTimer } from "react-icons/lu";
import { FaPlus } from "react-icons/fa";
import { GoPlus } from "react-icons/go";
import AttendenceList from "./AttendenceList";
import LeaveRequestList from "./LeaveRequestList";


const AttendenceTabs = () => {
  const [activeTab, setActiveTab] = useState("ListView");
  const [openModal, setOpenModal] = useState(null);

  // ✅ Mock Appointment Data
const AttendenceData = [
  {
    id: 1,
    name: "Dr. Sarah Johnson",
    department: "Medical",
    role: "Cardiologist",
    checkIn: "08:45 AM",
    checkOut: "05:30 PM",
    hours: 8.75,
    status: "Present",
  },
  {
    id: 2,
    name: "Dr. Michael Chen",
    department: "Medical",
    role: "Neurologist",
    checkIn: "09:15 AM",
    checkOut: "06:00 PM",
    hours: 8.75,
    status: "Present",
  },
  {
    id: 3,
    name: "Nurse Emma Wilson",
    department: "Nursing",
    role: "Head Nurse",
    checkIn: "08:00 AM",
    checkOut: "04:30 PM",
    hours: 8.5,
    status: "Present",
  },
  {
    id: 4,
    name: "James Rodriguez",
    department: "Laboratory",
    role: "Lab Technician",
    checkIn: "08:30 AM",
    checkOut: "05:00 PM",
    hours: 8.5,
    status: "Present",
  },
  {
    id: 5,
    name: "Lisa Thompson",
    department: "Administration",
    role: "Receptionist",
    checkIn: "08:55 AM",
    checkOut: "05:15 PM",
    hours: 8.33,
    status: "Present",
  },
  {
    id: 6,
    name: "Dr. Robert Davis",
    department: "Medical",
    role: "Pediatrician",
    checkIn: "10:30 AM",
    checkOut: "06:45 PM",
    hours: 8.25,
    status: "Late",
  },
];

const LeaveRequestData = [
  {
    id: 1,
    name: "Dr. Sarah Johnson",
    department: "Medical",
    leaveType: "Vacation",
    duration: "7 days",
    dates: "2023-06-10 to 2023-06-17",
    status: "Approved",
  },
  {
    id: 2,
    name: "Nurse Emma Wilson",
    department: "Nursing",
    leaveType: "Sick Leave",
    duration: "2 days",
    dates: "2023-05-20 to 2023-05-22",
    status: "Pending",
  },
  {
    id: 3,
    name: "James Rodriguez",
    department: "Laboratory",
    leaveType: "Personal",
    duration: "1 days",
    dates: "2023-05-25 to 2023-05-25",
    status: "Pending",
  },
  {
    id: 4,
    name: "Daniel Lee",
    department: "IT",
    leaveType: "Vacation",
    duration: "5 days",
    dates: "2023-05-15 to 2023-05-19",
    status: "Approved",
  },
];



  const tabButtonStyle = (key) =>
    `inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ${
      activeTab === key
        ? "bg-white text-black shadow-sm"
        : "text-muted-foreground hover:text-black"
    }`;

  return (
    <div className="space-y-4">
      {/* Tabs */}
      <h4 className="h4 mt-2">Daily Attendence List</h4>
      <div className="flex items-center justify-between mb-4">
        <div className="bg-[#f5f5f5] inline-flex flex-wrap items-center rounded-md p-1 text-muted-foreground mt-1">
          <button style={{}}
            onClick={() => setActiveTab("ListView")}
            className={tabButtonStyle("ListView")}
          >
            Daily Attendence
          </button>
          <button style={{}}
            onClick={() => setActiveTab("GridView")}
            className={tabButtonStyle("GridView")}
          >
            Leave Requests
          </button>
        </div>
        <button
  className="gradient-button"
  onClick={() => setOpenModal(activeTab === 'ListView' ? 'recordTimeModal' : 'newRequestModal')}
>
  {activeTab === "ListView" ? (
  <div style={{display:'flex',alignItems:'center'}}>
    <LuTimer style={{ marginRight: "4px" }} />
    Record Time
  </div>
) : (
  <div style={{display:'flex',alignItems:'center'}}>
    <GoPlus style={{ marginRight: "4px" }} />
    New Request
  </div>
)}
</button>

{openModal === 'recordTimeModal' && 
  <RecordTimeModal show={true} onClose={() => setOpenModal(null)} />
}
{openModal === 'newRequestModal' && 
  <NewRequestModal show={true} onClose={() => setOpenModal(null)} />
}
      </div>

      {/* Tab Content */}
      
        {activeTab === "ListView" && (
          <AttendenceList data={AttendenceData} />
        )}
        {activeTab === "GridView" && (
          <LeaveRequestList data={LeaveRequestData}/>
        )}
     
      <div>
        
      </div>
    </div>
  );
};

function RecordTimeModal({ show, onClose }) {
  return (
    <Modal show={show} onClose={onClose} centered>
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "8px",
          padding: "16px",
          width: "100%",
        }}
      >
        {/* Header */}
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center', marginBottom: "8px" }}>
        <div style={{alignItems: "center", gap: "8px" }}>
  <h2 style={{ fontSize: "20px", fontWeight: "600", margin: 0 }}>
    Record Attendance
  </h2>
  <p style={{ fontSize: "14px", color: "#6b7280", margin: 0 }}>
    Record check-in or check-out time for staff members.
  </p>
</div>

        <div onClick={onClose}><RxCross2 style={{cursor:'pointer'}}/></div>
        </div>

          {/* Staff Member */}
          <label
            style={{
              display: "block",
              fontSize: "14px",
              fontWeight: "500",
              marginBottom: "6px",
            }}
          >
            Staff Member
          </label>
          <select
            style={{
              width: "100%",
              padding: "10px",
              border: "1px solid #d1d5db",
              borderRadius: "6px",
              marginBottom: "16px",
              fontSize: "14px",
              color: "#374151",
            }}
          >
            <option>Select staff member</option>
          </select>

          {/* Record Type */}
          <label
            style={{
              display: "block",
              fontSize: "14px",
              fontWeight: "500",
              marginBottom: "6px",
            }}
          >
            Record Type
          </label>
          <select
            style={{
              width: "100%",
              padding: "10px",
              border: "1px solid #d1d5db",
              borderRadius: "6px",
              marginBottom: "16px",
              fontSize: "14px",
              color: "#374151",
            }}
          >
            <option>Select record type</option>
          </select>

          {/* Time */}
          <label
            style={{
              display: "block",
              fontSize: "14px",
              fontWeight: "500",
              marginBottom: "6px",
            }}
          >
            Time
          </label>
          <input
            type="time"
            style={{
              width: "100%",
              padding: "10px",
              border: "1px solid #d1d5db",
              borderRadius: "6px",
              marginBottom: "16px",
              fontSize: "14px",
              color: "#0e131aff",
            }}
          />

          {/* Notes */}
          <label
            style={{
              display: "block",
              fontSize: "14px",
              fontWeight: "500",
              marginBottom: "6px",
            }}
          >
            Notes (Optional)
          </label>
          <input
            placeholder="Add any additional notes"
            style={{
              width: "100%",
              padding: "10px",
              border: "1px solid #d1d5db",
              borderRadius: "6px",
              marginBottom: "20px",
              fontSize: "14px",
              color: "#374151",
            }}
          />

          {/* Footer */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px",
            }}
          >
            <button
              className="gradient-dark-button"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
            className="gradient-button"
            >
              Save Record
            </button>
          </div>
      </div>
    </Modal>
  );
}

function NewRequestModal({ show, onClose }) {
  return (
    <Modal show={show} onClose={onClose} centered>
      <div
        style={{
          background: "white",
          borderRadius: "8px",
          padding: "24px",
          width: "100%",
          outline: "none",
          boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
        }}
      >
        {/* Title */}
         <div style={{display:'flex',justifyContent:'space-between',alignItems:'center', marginBottom: "8px" }}>
        <div style={{alignItems: "center", gap: "8px" }}>
  <h2 style={{ fontSize: "20px", fontWeight: "600", margin: 0 }}>
     Submit Leave Request
  </h2>
  <p style={{ fontSize: "14px", color: "#6b7280", margin: 0 }}>
    Request time off or leave of absence.
  </p>
</div>

        <div onClick={onClose}><RxCross2 style={{cursor:'pointer'}}/></div>
        </div>

          {/* Staff Member */}
          <label
            style={{
              display: "block",
              fontSize: "13px",
              fontWeight: "500",
              color: "#6B7280",
              marginBottom: "6px",
            }}
          >
            Staff Member
          </label>
          <select
            style={{
              width: "100%",
              padding: "10px",
              border: "1px solid #D1D5DB",
              borderRadius: "6px",
              marginBottom: "16px",
              fontSize: "14px",
              color: "#111827",
            }}
          >
            <option>Select staff member</option>
          </select>

          {/* Leave Type */}
          <label
            style={{
              display: "block",
              fontSize: "13px",
              fontWeight: "500",
              color: "#6B7280",
              marginBottom: "6px",
            }}
          >
            Leave Type
          </label>
          <select
            style={{
              width: "100%",
              padding: "10px",
              border: "1px solid #D1D5DB",
              borderRadius: "6px",
              marginBottom: "16px",
              fontSize: "14px",
              color: "#111827",
            }}
          >
            <option>Select leave type</option>
          </select>

          {/* Start & End Date */}
          <div style={{ display: "flex", gap: "12px", marginBottom: "16px" }}>
            <div style={{ flex: 1 }}>
              <label
                style={{
                  display: "block",
                  fontSize: "13px",
                  fontWeight: "500",
                  color: "#6B7280",
                  marginBottom: "6px",
                }}
              >
                Start Date
              </label>
              <input
                type="date"
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #D1D5DB",
                  borderRadius: "6px",
                  fontSize: "14px",
                  color: "#111827",
                }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label
                style={{
                  display: "block",
                  fontSize: "13px",
                  fontWeight: "500",
                  color: "#6B7280",
                  marginBottom: "6px",
                }}
              >
                End Date
              </label>
              <input
                type="date"
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #D1D5DB",
                  borderRadius: "6px",
                  fontSize: "14px",
                  color: "#111827",
                }}
              />
            </div>
          </div>

          {/* Reason */}
          <label
            style={{
              display: "block",
              fontSize: "13px",
              fontWeight: "500",
              color: "#6B7280",
              marginBottom: "6px",
            }}
          >
            Reason (Optional)
          </label>
          <input
            type="text"
            placeholder="Brief explanation for the leave request"
            style={{
              width: "100%",
              padding: "10px",
              border: "1px solid #D1D5DB",
              borderRadius: "6px",
              marginBottom: "20px",
              fontSize: "14px",
              color: "#111827",
            }}
          />

          {/* Footer buttons */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px",
              marginTop: "8px",
            }}
          >
            <button
              className="gradient-dark-button"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
            className="gradient-button"
            >
              Submit Request
            </button>
          </div>
      </div>
    </Modal>
  );
}


export default AttendenceTabs;
